import React from 'react';
import clone from 'clone';
import classNames from 'classnames';

class SizeBox extends React.Component {
  constructor(props) {
    super(props);
    this.handleChecked = this.handleChecked.bind(this);
  }
  componentWillMount() {

  }
  handleChecked(e) {
    const values = [];
    this.options.forEach((item) => {
      if (item.key === parseInt(e.target.value, 10)) {
        item.isChecked = e.target.checked;
        values.push(item);
      }
    });
    this.props.onSelectSizeBox(values);
  }
  render() {
    this.options = clone(this.props.options);
    this.options.map((item) => {
      if (this.props.value.indexOf(item.slug) !== -1) {
        item.isChecked = true;
      }
    });
    const CustomClassNameMainSpan = classNames({
      'radio-input-content': true,
      'size-box-list': this.props.type === 'list',
    });
    const CustomClassName = classNames({
      'single-input size-box': true,
      'big': this.props.type === 'big',
      'list': this.props.type === 'list',

    });
    const singleSizeBoxItem = (item, index) => {
      return (
        <span className={CustomClassName} key={'sizebox-' + index}>
          <input type="radio" id={'sizebox-' + item.slug} checked={item.isChecked} value={item.key} onChange={this.handleChecked}/>
          <label className="" htmlFor={'sizebox-' + item.slug}>{item.value}</label>
        </span>
        );
    };
    const childInputClass = classNames('input-container', this.props.isOpenElement);
    return (
      <div className={childInputClass}>
        <span className={CustomClassNameMainSpan}>
          { this.options.length ? this.options.map(singleSizeBoxItem) : null }
        </span>
      </div>
    );
  }
}

SizeBox.propTypes = {
  'type': React.PropTypes.string,
  'value': React.PropTypes.array,
  'options': React.PropTypes.array,
  'onSelectSizeBox': React.PropTypes.func,
  'isOpenElement': React.PropTypes.string,
};

export default SizeBox;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/element/sizebox.js
 **/